import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import "./dashboard.css";
import { getVisitCountsDashboard, getWeeklyVisitCountsDashboard } from "../api/reportsAPI";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const NurseDashboard = () => {
  const [visitCounts, setVisitCounts] = useState(null);
  const [weeklyData, setWeeklyData] = useState([0,0,0,0,0]);
  const [weeklyCategories, setWeeklyCategories] = useState(["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect( async () => {
      let visits = await getVisitCountsDashboard();
      // console.log('visits',visits)
      if (visits && visits.data && visits.data.length > 0) {
        setVisitCounts(visits.data[0])
        //visits_counts
        //visits_pending_counts
        //visits_visited_counts        
      }
      
      await loadWeeklyVisits()
    }, [dispatch]);

  // Weekly Visits (Bar Chart)
  let weeklyVisits = {
    series: [
      {
        name: "Visits",
        data: weeklyData
      }
    ],
    options: {
      chart: {
        type: "bar",
        toolbar: { show: false }
      },
      colors: ["#2F80ED"],
      xaxis: {
        categories: weeklyCategories
      },
      dataLabels: { enabled: false },
      plotOptions: {
        bar: {
          borderRadius: 6
        }
      }
    }
  };

  const loadWeeklyVisits = async () => {
    let visits = await getWeeklyVisitCountsDashboard();
    if (visits && visits.data && visits.data.length > 0) {
      //console.log('visits',visits.data)
      let weeklyDataArray = []
      let weeklyCategoryArray = []
      for (let index = 0; index < visits.data.length; index++) {
        const element = visits.data[index];
        weeklyDataArray.push(element?.total_visits);
        weeklyCategoryArray.push(element?.day_name);          
      }  
      setWeeklyData(weeklyDataArray)    
      setWeeklyCategories(weeklyCategoryArray)    
    } 
  }

  // Visit Status (Donut Chart)
  const visitStatus = {
    series: [(visitCounts?.visits_visited_counts ?? 0), (visitCounts?.visits_pending_counts ?? 0)],
    options: {
      chart: {
        type: "donut"
      },
      labels: ["Completed", "Pending"],
      colors: ["#27AE60", "#F2994A"],
      legend: {
        position: "bottom"
      }
    }
  };


  const handleClickMenu = (url) => {
    navigate(url);
  }

  return (
    <div className="dashboard">
      {/* <h2>Nurse Dashboard</h2> */}

      {/* Summary Cards */}
      <div className="cards">
        <div className="card" onClick={()=>{handleClickMenu('/schedules')}}>📅 Today’s Visits: {visitCounts?.visits_counts ?? 0}</div>
        <div className="card" onClick={()=>{handleClickMenu('/visits')}}>✅ Completed: {visitCounts?.visits_visited_counts ?? 0}</div>
        <div className="card" onClick={()=>{handleClickMenu('/schedules')}}>⏳ Pending: {visitCounts?.visits_pending_counts ?? 0}</div>
      </div>

      {/* Charts */}
      <div className="charts">

        <div className="chart-card">
          <h3>Weekly Visits</h3>
          <Chart
            options={weeklyVisits.options}
            series={weeklyVisits.series}
            type="bar"
            height={300}
          />
        </div>

        <div className="chart-card">
          <h3>Today’s Visit Status</h3>
          <Chart
            options={visitStatus.options}
            series={visitStatus.series}
            type="donut"
            height={300}
          />
        </div>

      </div>
    </div>
  );
};

export default NurseDashboard;
